<template >

  <div id="spinner-wrapper" class="spinner-wrapper" v-if="showSpinner || showBackdrop" >
      <div class="spinner" v-if="showSpinner">
        <div></div>
        <div></div>
      </div>
  </div>

</template>


<script>

export default {
  name: 'Spinner',
  computed: {
    showSpinner() {
      // used a number value since we may have multiple axios calls going on at once
      return ( this.timer > 0 ) ? true : false;
    }
  },
  data() {
    return {
      timer: 0,
      showBackdrop: false,
    }
  },
  methods: {

    show( noSpinner=false ) {
      if ( noSpinner ) return this.showBackdrop = true;
      // this is to handle if the timer gets set below 0, unknown bug
      this.timer = ( this.timer >= 0 )
        ? this.timer + 1
        : 1;
    },

    hide( force=false ) {
      if ( force ) {
        this.showBackdrop = false;
        this.timer = 0;
      }
      else this.timer --;
    },

    changeIndex( zIndex=0 ) {
      if ( !zIndex ) return;
      try {
        document.getElementById('spinner-wrapper')
          .style
          .zIndex = zIndex;
      } catch (error) {}
    },

    //
    axios_FLA( method='get', url, data={} ) {
      this.show();

      return this.axios[method]( url, data )
        .then( res => {
          return res;
        } )
        .catch( e => {
          throw e;
        } )
        .finally( _ => {
          setTimeout( this.hide, 250 )
        } );
    }

  },

  mounted() {
    // // set global methods - we will keep these out for now
    // window.ShowSpinner = this.show;
    // window.HideSpinner = (x) => this.hide( x );

    // set this so we can use it in other components/views
    window.FLA_Axios = this.axios_FLA.bind(this);
    window.ShowBackdrop = this.show;
    window.HideBackdrop = this.hide;
    window.ChangeIndex = this.changeIndex;
  }
};

</script>

<style scoped>

/* doing this and not :root because this is scoped */
* {
  --size: 80px;
}

#test {
  display: flex;

}
.spinner-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: .5;
  background-color: gainsboro;
  z-index: 50;
}

.spinner {
    display: inline-block;
    position: absolute;
    width: var( --size );
    height: var( --size );
    top: calc( 50% - var( --size ) / 2 );
    left: calc( 50% - var( --size ) );
    transform: translate( 50%, -50% );
}
.spinner div {
    position: absolute;
    border: 4px solid black;
    opacity: 1;
    border-radius: 50%;
    animation: spinner 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.spinner div:nth-child(2) {
    animation-delay: -0.5s;
}
@keyframes spinner {
    0% {
        top: 36px;
        left: 36px;
        width: 0;
        height: 0;
        opacity: 1;
    }
    100% {
        top: 0px;
        left: 0px;
        width: 72px;
        height: 72px;
        opacity: 0;
    }
}

</style>